import { type ComponentType } from 'react'

interface GamePageRouteProps {
  Page: ComponentType
}

function GamePageRoute({ Page }: GamePageRouteProps) {
  return <Page />
}

export default GamePageRoute
